import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { WA_GREEN, normalizePhone } from "@/utils/whatsapp";
import { WhatsAppSendModal, type WaRecipient } from "./WhatsAppSendModal";

export function WhatsAppButton({ name, phone, type, id, testid }: { name: string; phone?: string | null; type: WaRecipient["type"]; id?: string; testid: string }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const digits = normalizePhone(phone);
    if (!digits) return null;
    return (
        <>
            <button type="button" data-testid={testid} title={t("uwa.send.title")} aria-label={t("uwa.send.title")}
                onClick={(e) => { e.stopPropagation(); setOpen(true); }}
                className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-150 hover:scale-110"
                style={{ background: `${WA_GREEN}1f`, color: WA_GREEN }}>
                <MessageCircle size={14} />
            </button>
            {open && <span onClick={(e) => e.stopPropagation()}><WhatsAppSendModal open={open} onClose={() => setOpen(false)} recipient={{ name, phone: digits, type, id }} /></span>}
        </>
    );
}
